import React from 'react';
import { useLocation } from 'react-router-dom';

const ImagePage = () => {
    const location = useLocation();
    const { base64Data, mimeType } = location.state || {}; // Retrieve Base64 data and MIME type from state
    console.log('Received Base64 Data:', base64Data); // Log received data
    console.log('Received MIME Type:', mimeType); // Log MIME type
    return (
        <div>
            <h1>Image Page</h1>
            {base64Data ? (
                <div>
                    <img
                        src={`data:${mimeType};base64,${base64Data}`} // Use the MIME type
                        alt="Uploaded"
                        style={{ maxWidth: '100%', height: 'auto' }}
                    />
                </div>
            ) : (
                <p>No image data available.</p>
            )}
        </div>
    );
};
export default ImagePage;
